import axios from 'axios';
import { apiMainUrl } from '../apiConfig';
import { normalizeApplicationResource } from '../Models/SecurityModels';

const API_URL = `${apiMainUrl}application-resources`;
const authConfig = token => ({ headers: { Authorization: `Bearer ${token}` } });

const getResources = async (accessToken, includeInactive = true) => {
    const response = await axios.get(API_URL, {
        ...authConfig(accessToken),
        params: { includeInactive }
    });
    const resources = Array.isArray(response.data)
        ? response.data
        : response.data?.items ?? response.data?.data ?? response.data?.results ?? [];
    return resources.map(normalizeApplicationResource);
};

export const ApplicationResourcesDataService = { getResources };
